export const supportedLanguages = ['en', 'pt', 'es'];

export const defaultLanguage = 'en';

const messages = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      projects: 'Projects',
      contact: 'Contact',
    },
    home: {
      eyebrow: 'Development and design studio',
      titleBefore: 'We turn ideas into clear, functional ',
      titleHighlight: 'digital products',
      titleAfter: '.',
      copy:
        'Nulamar combines development, design and strategy to create websites, systems and experiences with a focus on real delivery.',
      primaryCta: 'View projects',
      secondaryCta: 'Talk to the team',
    },
    about: {
      title: 'About',
      body:
        'Nulamar is a name inspired by the idea of a calm sea: a space where projects move with direction, planning and less friction. We started building together during graduation and now use that foundation to create digital products with code, design and research.',
    },
    projects: {
      title: 'Projects',
      intro: 'Selected work with context, visuals and the people involved in each delivery.',
      spotlight: 'Discover our public projects',
    },
    contact: {
      title: 'Contact',
      body:
        'Have an idea to validate, a site to launch or a product that needs a clearer shape? Tell us what you want to build.',
      emailLabel: 'Team contact:',
    },
    services: {
      title: 'Our Services',
    },
    team: {
      title: 'Team',
    },
    footer: {
      rights: 'All Rights Reserved.',
    },
  },
  pt: {
    nav: {
      home: 'Início',
      about: 'Sobre',
      projects: 'Projetos',
      contact: 'Contato',
    },
    home: {
      eyebrow: 'Estúdio de desenvolvimento e design',
      titleBefore: 'Transformamos ideias em ',
      titleHighlight: 'produtos digitais',
      titleAfter: ' claros e funcionais.',
      copy:
        'A Nulamar une desenvolvimento, design e estratégia para criar sites, sistemas e experiências com foco em entrega real.',
      primaryCta: 'Ver projetos',
      secondaryCta: 'Falar com a equipe',
    },
    about: {
      title: 'Sobre',
      body:
        'Nulamar é um nome inspirado na ideia de um mar calmo: um espaço onde os projetos avançam com direção, planejamento e menos atrito. Começamos a construir juntos durante a graduação e hoje usamos essa base para criar produtos digitais com código, design e pesquisa.',
    },
    projects: {
      title: 'Projetos',
      intro: 'Trabalhos selecionados com contexto, imagens e as pessoas envolvidas em cada entrega.',
      spotlight: 'Conheça nossos projetos públicos',
    },
    contact: {
      title: 'Contato',
      body:
        'Tem uma ideia para validar, um site para lançar ou um produto que precisa de forma mais clara? Conte para a gente o que você quer construir.',
      emailLabel: 'Contato da equipe:',
    },
    services: {
      title: 'Nossos Serviços',
    },
    team: {
      title: 'Equipe',
    },
    footer: {
      rights: 'Todos os direitos reservados.',
    },
  },
  es: {
    nav: {
      home: 'Inicio',
      about: 'Acerca de',
      projects: 'Proyectos',
      contact: 'Contacto',
    },
    home: {
      eyebrow: 'Estudio de desarrollo y diseño',
      titleBefore: 'Convertimos ideas en ',
      titleHighlight: 'productos digitales',
      titleAfter: ' claros y funcionales.',
      copy:
        'Nulamar combina desarrollo, diseño y estrategia para crear sitios web, sistemas y experiencias con foco en entrega real.',
      primaryCta: 'Ver proyectos',
      secondaryCta: 'Hablar con el equipo',
    },
    about: {
      title: 'Acerca de',
      body:
        'Nulamar es un nombre inspirado en la idea de un mar tranquilo: un espacio donde los proyectos avanzan con dirección, planificación y menos fricción. Empezamos a construir juntos durante la universidad y hoy usamos esa base para crear productos digitales con código, diseño e investigación.',
    },
    projects: {
      title: 'Proyectos',
      intro: 'Trabajos seleccionados con contexto, imágenes y las personas involucradas en cada entrega.',
      spotlight: 'Descubre nuestros proyectos públicos',
    },
    contact: {
      title: 'Contacto',
      body:
        '¿Tienes una idea para validar, un sitio para lanzar o un producto que necesita una forma más clara? Cuéntanos qué quieres construir.',
      emailLabel: 'Contacto del equipo:',
    },
    services: {
      title: 'Nuestros Servicios',
    },
    team: {
      title: 'Equipo',
    },
    footer: {
      rights: 'Todos los derechos reservados.',
    },
  },
};

export function detectLanguage() {
  if (typeof navigator === 'undefined') {
    return defaultLanguage;
  }

  const candidate = navigator.language?.slice(0, 2).toLowerCase();
  return supportedLanguages.includes(candidate) ? candidate : defaultLanguage;
}

export function getMessages(language = defaultLanguage) {
  return messages[language] || messages[defaultLanguage];
}
